import { Button } from "react-bootstrap";
import React from "react";
import "./header.css";

function Header() {
  return (
    <div className="header">
      <h1 className="prider text-center">P R I D E ++</h1>
      <div className="header-right">
        {/* <a href="#" className="header-icon">
          <i class="fab fa-instagram"></i>
        </a>
        <a href="#" className="header-icon">
          <i class="fab fa-twitter-square"></i>
        </a>
        <a href="#" className="header-icon">
          <i class="fab fa-youtube"></i>
        </a>
        <a href="#" className="header-icon">
          <i class="fab fa-facebook-square"></i>
        </a> */}
        {/* <button className="header-btn">Support Us</button> */}
        {/* <Button variant="warning" className="header-btn">
          Support Us
        </Button> */}
      </div>
    </div>
  );
}

export default Header;
